import { setPostNordAddressPoints, setPostNordPoint, setPostNordSelectedPoint } from './PostNord.action';

/** @namespace Bodymod/PostNord/Store/PostNord/Dispatcher */
export class PostNordDispatcher {
    setPostNordPoint(point, dispatch) {
        dispatch(setPostNordPoint(point));
    }

    setPostNordAddressPoints(points, dispatch) {
        dispatch(setPostNordAddressPoints(points));
    }

    setPostNordSelectedPoint(selectedPoint, dispatch) {
        dispatch(setPostNordSelectedPoint(selectedPoint));
    }
}

export default new PostNordDispatcher();
